'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBlogpostRouteProps = exports.getBlogposts = exports.getBlogpost = undefined;

var _lodash = require('lodash');

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _reselect = require('reselect');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _Filters = require('../Filters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParamsToPropsMap = {
  blogpostTitle: 'title'
};

var getBlogpost = exports.getBlogpost = function getBlogpost(_ref, _ref2) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var blogposts = _ref$cloudData.blogposts;
  var match = _ref2.match,
      _ref2$builderId = _ref2.builderId,
      builderId = _ref2$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref2$builderId;

  return _fp2.default.getOr([], builderId + '.data', blogposts).reduce(function (result, item) {
    if (result === undefined && (0, _bdcoreNamedRoutes.paramsMatch)((0, _lodash.get)(match, 'params', {}), routeParamsToPropsMap, item)) {
      return item;
    }

    return result;
  }, undefined);
};

var getBlogposts = exports.getBlogposts = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, props, builderId) {
  return builderId;
}, _Filters.getFilterValues, function (_ref3, _ref4) {
  var _ref3$cloudData = _ref3.cloudData;
  _ref3$cloudData = _ref3$cloudData === undefined ? {} : _ref3$cloudData;
  var blogposts = _ref3$cloudData.blogposts;
  var _ref4$builderId = _ref4.builderId,
      builderId = _ref4$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref4$builderId;
  return _fp2.default.getOr([], builderId + '.data', blogposts);
}], function (state, builderId, filters, blogposts) {
  return (0, _Filters.processFilters)(state, 'blogposts', blogposts, filters, builderId);
});

var getBlogpostRouteProps = exports.getBlogpostRouteProps = function getBlogpostRouteProps(blogpost, state) {
  return (0, _bdcoreNamedRoutes.getPropsFromItem)(blogpost, routeParamsToPropsMap, true, state);
};

exports.default = getBlogpost;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Blogposts/selectors.js
// module id = 494
// module chunks = 0